import React from 'react';

import { Container } from './styles';

const ButtonsPane: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ButtonsPane;
